function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import Parchment from 'parchment';
import Emitter from '../core/emitter';
import Block, { BlockEmbed } from './block';
import Break from './break';
import CodeBlock from '../formats/code';
import Container from './container';

function isLine(blot) {
  return blot instanceof Block || blot instanceof BlockEmbed;
}

var Scroll =
/*#__PURE__*/
function (_Parchment$Scroll) {
  _inherits(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    var _this;

    _classCallCheck(this, Scroll);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Scroll).call(this, domNode));
    _this.emitter = config.emitter;

    if (Array.isArray(config.whitelist)) {
      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    } // Some reason fixes composition issues with character languages in Windows/Chrome, Safari


    _this.domNode.addEventListener('DOMNodeInserted', function () {});

    _this.optimize();

    _this.enable();

    return _this;
  }

  _createClass(Scroll, [{
    key: "batchStart",
    value: function batchStart() {
      this.batch = true;
    }
  }, {
    key: "batchEnd",
    value: function batchEnd() {
      this.batch = false;
      this.optimize();
    }
  }, {
    key: "deleteAt",
    value: function deleteAt(index, length) {
      var _this$line = this.line(index),
          _this$line2 = _slicedToArray(_this$line, 2),
          first = _this$line2[0],
          offset = _this$line2[1];

      var _this$line3 = this.line(index + length),
          _this$line4 = _slicedToArray(_this$line3, 1),
          last = _this$line4[0];

      _get(_getPrototypeOf(Scroll.prototype), "deleteAt", this).call(this, index, length);

      if (last != null && first !== last && offset > 0) {
        if (first instanceof BlockEmbed || last instanceof BlockEmbed) {
          this.optimize();
          return;
        }

        if (first instanceof CodeBlock) {
          var newlineIndex = first.newlineIndex(first.length(), true);

          if (newlineIndex > -1) {
            first = first.split(newlineIndex + 1);

            if (first === last) {
              this.optimize();
              return;
            }
          }
        } else if (last instanceof CodeBlock) {
          var _newlineIndex = last.newlineIndex(0);

          if (_newlineIndex > -1) {
            last.split(_newlineIndex + 1);
          }
        }

        var ref = last.children.head instanceof Break ? null : last.children.head;
        first.moveChildren(last, ref);
        first.remove();
      }

      this.optimize();
    }
  }, {
    key: "enable",
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.domNode.setAttribute('contenteditable', enabled);
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, format, value) {
      if (this.whitelist != null && !this.whitelist[format]) return;

      _get(_getPrototypeOf(Scroll.prototype), "formatAt", this).call(this, index, length, format, value);

      this.optimize();
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, value, def) {
      if (def != null && this.whitelist != null && !this.whitelist[value]) return;

      if (index >= this.length()) {
        if (def == null || Parchment.query(value, Parchment.Scope.BLOCK) == null) {
          var blot = Parchment.create(this.statics.defaultChild);
          this.appendChild(blot);

          if (def == null && value.endsWith('\n')) {
            value = value.slice(0, -1);
          }

          blot.insertAt(0, value, def);
        } else {
          var embed = Parchment.create(value, def);
          this.appendChild(embed);
        }
      } else {
        _get(_getPrototypeOf(Scroll.prototype), "insertAt", this).call(this, index, value, def);
      }

      this.optimize();
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(blot, ref) {
      if (blot.statics.scope === Parchment.Scope.INLINE_BLOT) {
        var wrapper = Parchment.create(this.statics.defaultChild);
        wrapper.appendChild(blot);
        blot = wrapper;
      }

      _get(_getPrototypeOf(Scroll.prototype), "insertBefore", this).call(this, blot, ref);
    }
  }, {
    key: "leaf",
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: "line",
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }

      return this.descendant(isLine, index);
    }
  }, {
    key: "lines",
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      var getLines = function getLines(blot, index, length) {
        var lines = [],
            lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof Parchment.Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }

          lengthLeft -= length;
        });
        return lines;
      };

      return getLines(this, index, length);
    }
  }, {
    key: "optimize",
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.batch === true) return;

      _get(_getPrototypeOf(Scroll.prototype), "optimize", this).call(this, mutations, context);

      if (mutations.length > 0) {
        this.emitter.emit(Emitter.events.SCROLL_OPTIMIZE, mutations, context);
      }
    }
  }, {
    key: "path",
    value: function path(index) {
      return _get(_getPrototypeOf(Scroll.prototype), "path", this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: "update",
    value: function update(mutations) {
      if (this.batch === true) return;
      var source = Emitter.sources.USER;

      if (typeof mutations === 'string') {
        source = mutations;
      }

      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }

      if (mutations.length > 0) {
        this.emitter.emit(Emitter.events.SCROLL_BEFORE_UPDATE, source, mutations);
      }

      _get(_getPrototypeOf(Scroll.prototype), "update", this).call(this, mutations.concat([])); // pass copy


      if (mutations.length > 0) {
        this.emitter.emit(Emitter.events.SCROLL_UPDATE, source, mutations);
      }
    }
  }]);

  return Scroll;
}(Parchment.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [Block, BlockEmbed, Container];
export default Scroll;